import { fetch } from '../request'
import type { ProductUpdateMsg } from '../interface'
import type { IResponse } from '../interface/common'

// 获取更新弹窗内容接口
export const getProductUpdateMsg = () => {
  return fetch<IResponse<ProductUpdateMsg>>(
    '/promotion_center/product_update_notice/info/',
    {
      method: 'GET',
    }
  )
}
